module.exports = __webpack_public_path__ + "202408221624/img/haixiu.68b5248e.png";